import type { IconProps } from './schemas';

export function TranslationIcon({
  className = 'self-center inline-block',
}: IconProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={1.16667}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M1.75 3.30566H7.97222" />
        <path d="M4.86121 1.75V3.30556" />
        <path d="M3.30469 3.30566C3.37547 5.387 4.79491 7.17978 6.80469 7.72655" />
        <path d="M6.41667 3.30566C6.10556 7.68066 1.75 7.97233 1.75 7.97233" />
        <path d="M7.19531 12.2501L9.52865 6.02783H9.91753L12.2509 12.2501" />
        <path d="M7.9248 10.3057H11.522" />
      </g>
    </svg>
  );
}
